module.exports = __webpack_public_path__ + "img/tanker_nosignal.e06863b4.svg";